import {
  faArrowUpFromBracket as faArrowUpFromBracketRegular,
  faInboxFull as faInboxFullRegular,
  faTableLayout as faTableLayoutRegular,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowUpFromBracket as faArrowUpFromBracketSolid,
  faCircleInfo as faCircleInfoSolid,
  faInboxFull as faInboxFullSolid,
  faTableLayout as faTableLayoutSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, Text } from '@modusign/design-system';
import { useDispatch } from 'react-redux';

import { useGNBFoldHandle } from '@app/containers/GlobalNavigationBar/GNBFoldHandleContext';
import GNBLinkButtonIcon from '@app/containers/GlobalNavigationBar/GNBLinkButtonIcon';
import GuideTooltip from '@app/containers/GlobalNavigationBar/GuideTooltip';
import useGNBGuideActive from '@app/hooks/useGNBGuideActive';
import { useInvalidateDocumentList } from '@app/routes/Documents/useDocumentList';
import { initializeTemplatesData } from '@app/store/templates/actions';

import GlobalNavigationBarMenu from '../GlobalNavigationBarMenu';
import ExternalVideo from '../GuideTooltip/external.mp4';
import TemplateVideo from '../GuideTooltip/template.mp4';

function DocumentManagementSection() {
  const dispatch = useDispatch();
  const invalidate = useInvalidateDocumentList();
  const isGuideActive = useGNBGuideActive();

  const { folded } = useGNBFoldHandle();

  return (
    <Box as="section">
      {folded || (
        <Text as="div" color="textNeutralUltraLight" fontSize="sm" fontWeight="bold" p={3} pb={1}>
          문서
        </Text>
      )}
      <Flex
        alignItems={folded ? 'center' : 'initial'}
        as="ul"
        flexDirection="column"
        gap={folded ? 4 : 0}
      >
        <GlobalNavigationBarMenu
          leftIcon={<GNBLinkButtonIcon icon={faInboxFullRegular} />}
          leftIconActive={<GNBLinkButtonIcon icon={faInboxFullSolid} />}
          to="/documents"
          onClick={invalidate}
        >
          문서함
        </GlobalNavigationBarMenu>
        <GuideTooltip
          name="외부문서"
          title="종이계약 스캔본, 기타 PDF 파일 등 외부에서 보관·관리하고 있는 문서를 업로드하여 관리할 수 있어요."
          video={ExternalVideo}
        >
          <GlobalNavigationBarMenu
            isActive={(_, location) => location.pathname.startsWith('/external-document')}
            leftIcon={<GNBLinkButtonIcon icon={faArrowUpFromBracketRegular} />}
            leftIconActive={<GNBLinkButtonIcon icon={faArrowUpFromBracketSolid} />}
            rightIcon={isGuideActive && <FontAwesomeIcon icon={faCircleInfoSolid} width="11px" />}
            rightIconHovered={
              isGuideActive && (
                <FontAwesomeIcon color="iconEmphasisBase" icon={faCircleInfoSolid} width="11px" />
              )
            }
            to="/external-documents/list"
          >
            외부문서
          </GlobalNavigationBarMenu>
        </GuideTooltip>
        <GuideTooltip
          name="템플릿"
          primaryBadges={['Trial기간 무제한 제공']}
          title="텍스트, 체크박스, 사인·도장 입력란 등을 미리 지정하여 바로 서명 요청이 가능한 템플릿으로 만들 수 있어요."
          video={TemplateVideo}
        >
          <GlobalNavigationBarMenu
            leftIcon={<GNBLinkButtonIcon icon={faTableLayoutRegular} />}
            leftIconActive={<GNBLinkButtonIcon icon={faTableLayoutSolid} />}
            rightIcon={isGuideActive && <FontAwesomeIcon icon={faCircleInfoSolid} width="11px" />}
            rightIconHovered={
              isGuideActive && (
                <FontAwesomeIcon color="iconEmphasisBase" icon={faCircleInfoSolid} width="11px" />
              )
            }
            to="/templates"
            onClick={() => {
              dispatch(initializeTemplatesData());
              // TODO(org3): 템플릿 UI에서 필터 초기화 하기
              // if (hasOrganization) {
              // dispatch(changeTemplatesFilters({ teamId }));
              // }
            }}
          >
            템플릿
          </GlobalNavigationBarMenu>
        </GuideTooltip>
      </Flex>
    </Box>
  );
}

export default DocumentManagementSection;
